import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

// Fetch a single billable for the form, including all billing config subfields
export async function fetchBillableDataForForm({ id }) {
  try {
    const query = {
      fields: [
        "*",
        "fixed_billing_config.*",
        "hourly_billing_config.*",
        "dedicated_billing_config.*",
        "milestones.id",
        "milestones.name",
        "milestones.billable_hours",
        getUserFields("attributed_to"),
      ],
    };

    const response = await getItemFromCollection("billables", id, query);

    return response;
  } catch (error) {
    console.error("Error fetching billable data:", error);
    throw error;
  }
}
